import { tokens } from '../../public/tokens';

const { typography } = tokens;

/**
 * Base style that strips a <ul>/<ol> back to a plain vertical stack. Spread it in,
 * then add gap.
 */
export const listResetStyle = {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
};

/**
 * Centres a Font Awesome icon inside a fixed-size badge. Caller sets width/height.
 */
export const iconBadge = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: typography.fontSize['base-16px'],
};
